<div class="sociologin">
  <div class="modal-login__text my-2" [ngClass]="{'color-green': isEmailOtp}">
    <span>
      {{ isEmailOtp
        ? 'Please check your email for OTP verification'
        : 'Invoices will be sent to following mail please provide a valid one.' }}
    </span>
  </div>

  <!-- Email Field -->
  <div class="mb-3 py-2">
    <label class="form-label">E-mail (optional)</label>
    <input
      type="text"
      class="form-control form-control-sm"
      emailValidator
      [formControl]="email"
      name="email"
    />

    <div class="text-danger mt-1" *ngIf="submitted && email?.errors?.isValid">
      Email is required and format should be <strong>john@doe.com</strong>
    </div>
  </div>

  <!-- OTP Field -->
  <div class="mb-3" *ngIf="isEmailOtp">
    <label class="form-label">OTP</label>
    <input
      type="text"
      class="form-control form-control-sm"
      [formControl]="otp"
      name="otp"
    />

    <div class="text-danger mt-1" *ngIf="submitted && otp?.errors?.required">
      OTP is <strong>required</strong>
    </div>

    <small
      class="text-primary cursor-pointer"
      *ngIf="submitted && otp?.errors?.invalidOTP"
      (click)="resendOtp()"
    >
      Resend OTP
    </small>

    <div class="text-danger mt-1" *ngIf="submitted && otp?.errors?.invalidOTP">
      Invalid <strong>OTP</strong>
    </div>
  </div>

  <!-- Submit Button -->
  <div class="mb-3">
    <button class="btn btn-primary btn-sm login-btn" (click)="submit()">
      {{ isEmailOtp ? 'VERIFY OTP' : 'SUBMIT' }}
    </button>
  </div>

  <!-- Skip Link -->
  <div class="modal-login__signup">
    <span class="modal-login__signup--link" (click)="skip.emit()">Skip</span>
  </div>
</div>
